module.exports = __webpack_public_path__ + "static/media/Primate-House6.506ff42f.jpg";